// extracted by mini-css-extract-plugin
export default {"teams-page":"TeamsPage_teams-page__b9b-O"};